import { toLocalISOString } from '../../utils/datetime';
import { goalCreateSchema, goalUpdateSchema } from './schema';
import type {
  GoalCreate,
  GoalCreateInput,
  GoalUpdate,
  GoalUpdateInput,
} from './types';

export function prepareGoalUpdate(data: GoalUpdateInput): GoalUpdate {
  const update: GoalUpdate = { ...data };

  if ('status' in update) {
    if (update.status === 'done') {
      const now = new Date();
      update.doneAt = now;
      update.doneAtLocal = toLocalISOString(now);
    } else {
      update.doneAt = null;
      update.doneAtLocal = null;
    }
  }

  return goalUpdateSchema.parse(update);
}

export function prepareGoalCreate(data: GoalCreateInput): GoalCreate {
  const create = {
    ...data,
    id: crypto.randomUUID(),
    status: 'open',
    doneAt: null,
    doneAtLocal: null,
    parentGoalId: data.parentGoalId ?? null,
  };

  return goalCreateSchema.parse(create);
}
